<script setup>
// Shared field chrome: label + optional hint + optional error, wired to the
// control by id for the label association. Errors are never vague (§9) and are
// carried by text + the rejected hue as a graphical marker, not colour alone.
import { useId } from 'vue'

defineProps({
	label: { type: String, default: null },
	hint: { type: String, default: null },
	error: { type: String, default: null },
	required: { type: Boolean, default: false },
})
const id = useId()
</script>

<template>
	<div class="l-field">
		<div v-if="label" class="lbl-row">
			<label :for="id" class="lbl">
				{{ label }}<span v-if="required" class="req" aria-hidden="true"> *</span>
			</label>
			<!-- Optional action beside the label, e.g. a "Manage" link. -->
			<slot name="label-action" />
		</div>
		<slot :id="id" :invalid="!!error" />
		<p v-if="error" class="err">{{ error }}</p>
		<p v-else-if="hint" class="hint">{{ hint }}</p>
	</div>
</template>

<style scoped>
.l-field
{
	display: flex;
	flex-direction: column;
	gap: 6px;
}

.lbl-row
{
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: var(--sp-2);
}

.lbl
{
	font-size: var(--text-chip);
	font-weight: 600;
	color: var(--text-2);
}

.req
{
	color: var(--status-rejected-text);
}

.hint
{
	font-size: var(--text-chip);
	color: var(--text-3);
}

.err
{
	font-size: var(--text-chip);
	color: var(--status-rejected-text);
	font-weight: 500;
}
</style>
